import React, {Component} from "react";

// FUNKTIONIERT NOCH NICHT!!!

class RadioButton extends Component {

    getRadioButtons = () => {
        const {
            itemList,
            valueProperty,
            textProperty,
            value,
            handleCheckboxChange
        } = this.props;

        return (
            itemList.map(item => {

                let checked = false;
                if (value && value[item[valueProperty]] && value[item[valueProperty]]["checked"] === true)
                    checked = true;
                console.log("RadioButton.getRadioButtons(): item=", item, ", checked=", checked)
                return (
                    <div className="form-check" key={item[valueProperty]}>
                        <input
                            className="form-check-input"
                            type="radio"
                            name="radioButtonss"
                            id={item.dbId}
                            value={item.dbId}
                            checked={checked}
                        />
                        <label className="form-check-label" htmlFor={item.dbId}>
                            {item.name}
                        </label>
                    </div>
                );
            })
        )
    }

    render = () => {

        const {
            itemList,
            itemsMap,
            valueProperty,
            textProperty,
            name,
            label,
            error,
            help,
            handleItemSelect,
            value,
            nullable,
            enterValue,
            ...rest
        } = this.props;

        return (
            <div className="form-group">
                <label htmlFor={name}>{label}</label>
                {/*<div*/}
                {/*    className="checkbox-container"*/}
                {/*>*/}
                {this.getRadioButtons()}
                {/*</div>*/}

                {help && (
                    <small id={`${name}Help`} className="form-text text-muted">
                        {help}
                    </small>
                )}
                {error && <div className="alert alert-danger">{error}</div>}
            </div>
        );

    }

}

RadioButton
    .defaultProps = {
    valueProperty: "dbId",
    textProperty: "name",
    nullable: true,
    enterValue: false
};

export default RadioButton;
